import { posthog } from "posthog-js";
import { useState } from "react";

import { useAcceptAllInvites } from "./useAcceptAllInvites";

import { useSignup } from "@/queries/auth";
import { useAuth } from "@/context/auth-context";
import { ToastType } from "@/enums/toast";
import { CreateAccountFromInviteParams } from "@/types/workspace-invite";
import { displayErrorToast, displayToast } from "@/utils/toast";

export const useCreateAccountFromInvite = (onError?: (verdict: string) => void) => {
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const { mutate: createAccount } = useSignup(onError);
  const { acceptAllInvites } = useAcceptAllInvites();

  const createAccountFromInvite = ({
    name,
    email,
    password,
    invite_ids,
  }: CreateAccountFromInviteParams) => {
    setIsLoading(true);
    createAccount(
      {
        name: name,
        email: email,
        password: password,
      },
      {
        onSuccess: async data => {
          displayToast("Account created successfully", ToastType.success);
          const { access_token, user } = data;
          auth?.login(access_token, user);
          posthog.capture("Signed Up");
          await acceptAllInvites(invite_ids, access_token);
          setIsLoading(false);
          setSuccess(true);
        },
        onError: () => {
          displayErrorToast("Failed to create account. Please try again.");
          setIsLoading(false);
        },
      },
    );
  };

  return { createAccountFromInvite, isLoading, success };
};
